<template>
  <div class="content">
    <el-card class="box-card" v-hasPermi="['system:dashboard']">
        <div slot="header" class="clearfix">
          <span style="font-weight: bolder">{{ $t('app.dashboard.operationStats') }}</span>
          <span v-show="username == 'juzi001'" v-for="(item,index) in curData" :key="index" class="curClass" :class="{cur: curIndex === index}" @click="curButton(item,index)">{{item}}</span>
        </div>
        <div class="order" v-hasPermi="['system:dashboard']">
          <div class="lists" style="background:#36A3F7;" v-hasPermi="['system:dashboard:orderCount']">
            <div class="amount">
              <p style="color:#fff">{{ $t('app.dashboard.orderCount') }}</p>
              <p style="font-size: 18px;">
                <!-- <countTo :startVal="startVal" :endVal="ordernumber" :duration="2000"></countTo> -->
                <el-statistic>
                    <template slot="formatter">
                      {{ordernumber}}
                    </template>
                </el-statistic>
              </p> 
            </div>
          </div>
          <div class="lists" style="background:#30C7C9;" v-hasPermi="['system:dashboard:orderMoney']">
            <div class="amount">
              <p style="color:#fff">{{ $t('app.dashboard.orderAmount') }}</p>
              <p style="font-size: 18px;">
                <!-- <countTo :startVal="startVal" :endVal="orderamount" :duration="2000" :decimals="1"></countTo> -->
              <el-statistic>
                  <template slot="formatter">
                    {{orderamount}}
                  </template>
              </el-statistic>
                
              </p>
            </div>
          </div>
          <div class="lists" style="background:#B6A2DE;" v-hasPermi="['system:dashboard:commission']">
            <div class="amount">
              <p style="color:#fff">{{ $t('app.dashboard.commissionAmount') }}</p>
              <p style="font-size: 18px;">
                <!-- <countTo :startVal="startVal" :endVal="ordercommission" :duration="2000"></countTo> -->
                <el-statistic>
                    <template slot="formatter">
                      {{ordercommission}}
                    </template>
                </el-statistic>
              </p>
            </div>
          </div>
          <div class="lists" style="background:#F39494;" v-show="adminShow" v-hasPermi="['system:dashboard:newCard']">
            <div class="amount">
              <p style="color:#fff">{{ $t('app.dashboard.changeCardAmount') }}</p>
              <p style="font-size: 18px;">
                <el-statistic>
                    <template slot="formatter">
                      {{changeCardAmount}}
                    </template>
                </el-statistic>
              </p>
            </div>
          </div>
          <div class="lists" style="background:#E6A23C;" v-show="adminShow" v-hasPermi="['system:dashboard:stopCard']">
            <div class="amount">
              <p style="color:#fff">{{ $t('app.dashboard.keepCardAmount') }}</p>
              <p style="font-size: 18px;">
                <el-statistic>
                    <template slot="formatter">
                      {{keepCardAmount}}
                    </template>
                </el-statistic>
              </p>
            </div>
          </div>
          <div class="lists listsxianshi" style="background:#0099CC;" v-hasPermi="['system:dashboard:totalMoney']" v-show="adminShow" @mouseover="mouseOver" @mouseleave="mouseLeave">
            <div class="amount">
              <p style="color:#fff">{{ $t('app.dashboard.totalAmount') }}</p>
              <p style="font-size: 18px;">
                <!-- <countTo :startVal="startVal" :endVal="totalAmount" :duration="2000" :decimals="1"></countTo> -->
                <el-statistic>
                    <template slot="formatter">
                      {{totalAmount}}
                    </template>
                </el-statistic>
              </p>
            </div>
            <div class="money-none" v-if="moneyShow">
              <p>桔子智联{{jzzlAmount}}</p>
              <p>桔子智联云{{jzzlyAmount}}</p>
              <p>桔子智联中心{{jzzlzxAmount}}</p>
              <p>前海云领{{qhylAmount}}</p>
            </div>
          </div>
        </div>
    </el-card>
    <el-card class="box-card" v-hasPermi="['system:order:statistics']">
        <div slot="header" class="clearfix">
          <el-link v-if="adminShow" type="primary" @click="buttonOrder" style="font-weight: bolder;font-size: 16px;font-weight: 300;">{{ $t('app.dashboard.orderStats') }}</el-link>
          <span v-else style="font-weight: bolder">{{ $t('app.dashboard.orderStats') }}</span>
          <div style="float: right; padding: 3px 0">
            <el-radio-group v-model="dateRadio"  @change="checkCard">
              <el-radio-button label="日">{{ $t('app.dashboard.daily') }}</el-radio-button>
              <el-radio-button label="月">{{ $t('app.dashboard.monthly') }}</el-radio-button>
              <el-radio-button label="年">{{ $t('app.dashboard.yearly') }}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div id="main" class="simpleDemo" v-if="checkPermi(['system:order:statistics'])" ></div>
    </el-card>
    <!-- 三大运营商的统计 -->
    <el-card class="box-card" v-if="checkPermi(['system:flow:statistics'])">
        <div slot="header" class="clearfix">
          <span style="font-weight: bolder">{{ $t('app.dashboard.flowStats') }}</span>
          <svg-icon class="svg-header" icon-class="refresh" class-name="icon-refresh" @click.prevent="handleFlowRefresh"/>
        </div>
        <panel-group ref="flowRefresh" />
    </el-card>
    <el-card v-show="adminShow" class="box-card" v-hasPermi="['system:card:cycle']">
        <div slot="header" class="clearfix">
          <span style="font-weight: bolder">{{ $t('app.dashboard.lifeCycleDist') }}</span>
        </div>
        <el-row :gutter="20">
          <el-col :xs="24"  :lg="8">
            <svg-icon class="svg-refresh" icon-class="refresh" class-name="icon-refresh" @click.prevent="handleCycleCard"/>
            <card-life-cycle-chart :chart-data="cardLifeCycleData" ></card-life-cycle-chart>
          </el-col>
          <el-col :xs="24"  :lg="10">
            <div id="cardStopActiveEchart" style="width: 100%;height: 300px;background: #fff;border-radius: 8px;"></div>
          </el-col>
          <el-col :xs="24"  :lg="6">
            <div class="top-content" style="height: 300px;background: #fff;border-radius: 8px;">
                <svg-icon class="svg-top" icon-class="refresh" class-name="icon-refresh" @click.prevent="handleTopFlow"/>
                <div class="top-title">{{ $t('app.dashboard.todayTopRank') }}</div>
                <div class="table-head"><span>MSISDN</span><span>{{ $t('app.dashboard.usage') }} (<span style="color:red">GB</span>)</span></div>
                <ul style="height: 200px">
                  <li v-for="(item,index) in rankingList" :key="index">
                    <div>
                      <span class="number-bg">{{index + 1}}</span>
                      <span @click="cardInfo(item.iccid)">{{item.msisdn == '无' ? item.iccid : item.msisdn}}</span>
                    </div>
                    <div>
                      <span>{{(item.todayFlow/1024).toFixed(0)}}</span>
                    </div>
                  </li>
              </ul>
            </div>
          </el-col>
        </el-row>
    </el-card>
    <!-- 物联卡全国定向Cat1流量1块8元套餐（共享）CMMTMJZZL -->
    <template v-if="adminShow && checkPermi(['system:smallFlow:statistics'])">
      <el-card  class="box-card"  v-for="item in sourceFlow" :key="item.groupId">
        <div slot="header" class="clearfix">
            <div class="title-container">
              <span class="main-title" style="font-weight: bolder">{{item.groupName}}
                <el-tooltip content="以下图表1和图表3展示的是显示状态数据" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <!--点击跳转群组 groupInfo() -->
              <span class="sub-title"><el-link type="primary" :underline="false" @click="groupInfo(item.groupId)">{{item.groupId}}</el-link><span style="color: #52c41a;">（{{item.shareName}}{{item.shareFlow}}MB）</span></span>
            </div>
        </div>
        <el-row :gutter="20">
          <el-col :xs="24" :lg="10">
            <svg-icon class="svg-refresh" icon-class="refresh" class-name="icon-refresh" @click.prevent="handleSmallCardCountRefresh(item.groupId)" />
            <indexPie :groupId="item.groupId" :ref="item.groupId"></indexPie>
            <div class="echart-bootom-tip">平台卡数统计</div>
          </el-col>
          <el-col :xs="24" :lg="14">
            <svg-icon class="svg-refresh" icon-class="refresh" class-name="icon-refresh" @click.prevent='handleSmallCardStatusRefresh(item.groupId)'/>
            <dashboardIndex :groupId="item.groupId" :ref="'card-status-' + item.groupId"></dashboardIndex>
            <div class="echart-bootom-tip" v-if="item.pool == '1'">运营商数据</div>
            <div class="echart-bootom-tip" v-if="item.pool == '0'">平台数据</div>
          </el-col>
        </el-row>
      </el-card>
    </template>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { lineChart } from "@/api/dashboard";//金额柱形图 
import { todayTopCard } from "@/api/api.js";//top5
import { cardStopActiveLineChart } from "@/api/api.js";//激活数与停机数
import { cardSourceHash , sourceShareFlow } from "@/api/api.js";//生命周期统计
import dashboardIndex from "@/components/dashboard/index.vue";
import indexPie from "@/components/dashboard/indexPie.vue";
import PanelGroup from './dashboard/PanelGroup.vue'
import CardLifeCycleChart from './dashboard/CardLifeCycleChart.vue'
export default {
  components: { 
    dashboardIndex,
    indexPie,
    PanelGroup,
    CardLifeCycleChart,
  },
  data() {
    return {
      startVal: 0,
      orderamount: 0,
      ordernumber: 0,
      ordercommission:0,
      keepCardAmount:0,
      changeCardAmount:0,
      totalAmount:0,
      jzzlyAmount:"",
      jzzlAmount:"",
      jzzlzxAmount:"",
      qhylAmount:"",
      activeIndex: 0,
      dateRadio:'日',
      data: ["日","月","年"],
      curData:["人民币","美元","欧元","英镑","日元","泰铢",],
      commissionAmountList:[], //佣金列表
      orderAmountList: [], //订单金额
      orderNumberList: [], //订单数量
      timeList: [], //时间
      smsNumberList:[],
      smsAmountList:[],
      smsCommissionAmountList:[],
      // 流量统计
      operatorsData:{
        telecom:'',
        move:'',
        unicom:''
      },
      // 激活数停机数的折线图数据
      stopCardTimeList:[],  //时间
      activeCardList:[],  //激活数
      stopCardList:[],  //停机数
      pielistData:[],
      // 排名top5:
      rankingList:[],
      moneyShow:false,
      curShow:false,
      curIndex:0,
      currencyData:"人民币",
      cardLifeCycleData:[],
      flowRefresh:0,
      sourceFlow:[]
    };
  },
  computed: {
    adminShow (){
        return this.$store.getters.user.userType =='1'
    },
    username(){
        return this.$store.getters.name
    }
  },
  methods: {
    curButton(item,index){
      this.currencyData = item;
      this.curIndex = index;
      this.getOrderInfo();
      this.activeIndex = 0
    },
    curMouseover(){
      this.curShow = true;
    },
    curMouseLeave(){
      this.curShow = false;
    },
    // 跳转订单数据统计
    buttonOrder(){
      this.$router.push("/order/statistics");
    },
    mouseOver(){
      this.moneyShow = true
    },
    mouseLeave(){
      this.moneyShow = false
    },
    // 金额柱形图
    listEcharts() {
      let seriesData = [
            {
              name:  this.$t('app.dashboard.orderCount'),
              type: "bar", //line  bar
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.orderNumberList,
            },
            {
              name: this.$t('app.dashboard.commissionAmount'),
              type: "bar",
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.commissionAmountList,
            },
            {
              name: this.$t('app.dashboard.orderAmount'),
              type: "bar",
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.orderAmountList,
            },
          ];
      if(this.checkPermi(['system:sms:statistics'])){
        seriesData = [
            {
              name: "流量订单数量",
              type: "bar", //line  bar
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.orderNumberList,
            },
            {
              name: "流量佣金金额",
              type: "bar",
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.commissionAmountList,
            },
            {
              name: "流量订单金额",
              type: "bar",
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.orderAmountList,
            },
            {
              name: "短信订单数量",
              type: "bar",
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.smsNumberList,
            },
            {
              name: "短信订单佣金",
              type: "bar",
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.smsCommissionAmountList,
            },
            {
              name: "短信订单金额",
              type: "bar",
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.smsAmountList,
            },
          ];
      }
      setTimeout(() => {
        var option = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            y: "470px",
          },
          color: [ "#36A3F7","#B6A2DE",'#30C7C9',"#36A3F7","#B6A2DE",'#30C7C9'],
          xAxis: [
            {
              type: "category",
              data: this.timeList,
              axisPointer: {
                type: "shadow",
              },
              axisLine: {
                //坐标轴轴线相关设置。
                lineStyle: {
                  color: "#2B2F3A",
                }
              },
              axisLabel: {
                interval:0,
                rotate:0//角度顺时针计算的
              }
            },
          ],
          yAxis: {
            nameTextStyle: {
              color: "#FA6F53",
              fontSize: 16,
              padding: [0, 0, 10, 0]
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#2B2F3A"
              }
            },
            type: "value"
          },
          animationDuration: 2000, //动画时间
          animationEasing: 'BounceOut',  //BounceOut设置动画效果 cubicInOut
          series: seriesData,
        };
        var myChart = echarts.init(document.getElementById("main"));
        option && myChart.setOption(option);
        window.addEventListener("resize",function(){
          myChart.resize();
        });
      },80)
    },
    // 金额柱形图切换年月日
    checkCard(val) {
      this.getOrderInfo(val);
    },
    // 金额柱形图切换年月日
    getOrderInfo(type = "日") {
      if(!this.checkPermi(['system:order:statistics'])){
        return false;
      }
      let params = {
        type: type,
        currency:this.currencyData
      };
      lineChart(params).then(res => {
          this.timeList = res.data.data.timeList;
          this.orderAmountList = res.data.data.orderAmountList;
          this.orderNumberList = res.data.data.orderNumberList;
          this.commissionAmountList = res.data.data.commissionAmountList;

          this.smsNumberList = res.data.data.smsNumberList;
          this.smsAmountList = res.data.data.smsAmountList;
          this.smsCommissionAmountList = res.data.data.smsCommissionAmountList;

          this.ordernumber = Number(res.data.data.normalNumber);//订单数
          this.orderamount = res.data.data.normalAmount;//订单金额
          this.ordercommission = res.data.data.commissionAmount;//佣金
          if(this.adminShow){
            this.keepCardAmount = Number(res.data.data.keepCardAmount);//停机保号金额
            this.changeCardAmount = Number(res.data.data.changeCardAmount);//补卡金额
            let orderAppNameHashList = res.data.data.orderAppNameHashList;
            if(!!orderAppNameHashList){
              this.jzzlAmount = Math.round(res.data.data.orderAppNameHashList[1].appMoneyCount);
              this.jzzlyAmount = Math.round(res.data.data.orderAppNameHashList[0].appMoneyCount);
              this.jzzlzxAmount = Math.round(res.data.data.orderAppNameHashList[2].appMoneyCount);
              this.qhylAmount = Math.round(res.data.data.orderAppNameHashList[3].appMoneyCount);
            }
            this.totalAmount = Number(res.data.data.normalAmount) + Number(res.data.data.keepCardAmount) + Number(res.data.data.changeCardAmount);//总金额
          }
          this.listEcharts(); 
      });
    },
    sum(arr) {
      var sumResult = 0; 
      for (var i = 0; i < arr.length; i++) { 
      　sumResult += parseInt(arr[i]); 
      } 
      return sumResult
    },
    // 卡源的饼图
    handleCardLifeCycleData(){
      if(!this.checkPermi(['system:card:cycle'])){
        return false;
      }
      cardSourceHash({refresh:"0"}).then(res=>{
        this.cardLifeCycleData = res.data.data;
      })
    },
    // 卡源的激活数停机数
    cardStopActiveLine(){
      if(!this.checkPermi(['system:card:cycle'])){
        return false;
      }
      cardStopActiveLineChart().then(res=>{
        this.stopCardTimeList = res.data.data.timeList;
        this.activeCardList = res.data.data.activeList;
        this.stopCardList = res.data.data.stopList;
        this.cardStopActiveEcharts();
      })
    },
    // 卡源的激活数折线图
    cardStopActiveEcharts(){
      if(!this.checkPermi(['system:card:cycle'])){
        return false;
      }
      setTimeout(() => {
        var option = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            y: "275px",
          },
          xAxis: [
            {
              type: "category",
              data: this.stopCardTimeList,
              axisPointer: {
                type: "shadow",
              },
            },
          ],
          yAxis: {
            nameTextStyle: {
              color: "#FA6F53",
              fontSize: 16,
              padding: [0, 0, 10, 0]
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#2B2F3A"
              }
            },
            type: "value"
          },
          animationDuration: 1500, //动画时间
          animationEasing: 'BounceOut',  //BounceOut设置动画效果 cubicInOut
          series: [
            {
              name: "激活数",
              smooth:true,//线条平滑
              type: "bar", //line  bar
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.activeCardList,
            },
            {
              name: "停机数",
              smooth:true,//线条平滑
              type: "bar",
              barGap: "0",
              barWidth: "18%", //柱图宽度
              data: this.stopCardList,
            },
          ],
        };
        let cardStopActiveEchart = echarts.init(document.getElementById("cardStopActiveEchart"));
        option && cardStopActiveEchart.setOption(option);
        window.addEventListener("resize",function(){
          cardStopActiveEchart.resize()
        });
      },80)
    },
    // top5
    top5Data(refresh){
      todayTopCard({refresh}).then(res=>{
        this.rankingList = res.data.data;
      })
    },
    // 跳转详情
    cardInfo(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
    handleFlowRefresh(){
      this.$refs.flowRefresh.handleMonthFlow(1);
      this.$message({message: '刷新成功',type: 'success', duration:1000});
    },
    handleSmallCardCountRefresh(groupId){
      this.$refs[groupId][0].smallFlow(1);
      this.$message({message: '刷新成功',type: 'success', duration:1000});  
    },
    handleSmallCardStatusRefresh(groupId){
      this.$refs['card-status-' + groupId][0].smallFlow(1);
      this.$message({message: '刷新成功',type: 'success', duration:1000}); 
    },
    handleSmallShowStatusRefresh(groupId){
      this.$refs[groupId][0].smallFlow(1);
      this.$message({message: '刷新成功',type: 'success', duration:1000});
    },
    handleCycleCard(){
      cardSourceHash({refresh:"1"}).then(res=>{
        this.cardLifeCycleData = res.data.data;
        this.$message({message: '刷新成功',type: 'success', duration:1000});
      })
    },
    handleTopFlow(){
      this.top5Data(1);
      this.$message({message: '刷新成功',type: 'success', duration:1000});
    },
    groupInfo(groupId){
      this.$router.push('/card/groupCard/' + groupId);
    },
    selectSourceFlow(){
      if(this.checkPermi(['system:smallFlow:statistics'])){
        sourceShareFlow().then(res=>{
          this.sourceFlow = res.data.data
        })
      }
    }
  },
  mounted() {
    this.$i18n.locale = localStorage.getItem('app_language') || 'zh'
  },
  created() {
    this.getOrderInfo();
    this.selectSourceFlow(); 
    if(this.adminShow){
      this.cardStopActiveLine();
      this.top5Data(0);
      this.handleCardLifeCycleData();
    }

  }
};
</script>
<style scoped lang="less">
  .top-content {
    height: 320px;
    // padding: 0px 6px 0px 6px;
    // 鼠标放上去  手型
    .svg-top{
      float: left;
      position: absolute;
      margin-top: 11px;
      margin-left: 6px;
      font-size: 20px;
      z-index: 6;
      cursor: pointer;
    }
    .top-title{
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #E7EAF3;
      font-size: 16px;
      color: #333;
      margin: 0 auto;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
    p{
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #E7EAF3;
      font-size: 14px;
      color: #899caf;
      margin: 0 auto;
    }
    .table-head{
      padding: 0px 10px 0px 10px;
      background: #E7EAF3;
      color: #899caf;
      font-size: 14px;
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      background: #F7F5F0;
      // margin-top: 5px;
    }
    ul{
      li{
        padding: 0px 16px 0px 10px;
        height: 42px;
        line-height: 42px;
        display: flex;
        justify-content: space-between;
        color: #3398db;
        font-size: 14px;
        cursor: pointer;
        .number-bg{
          display: inline-block;
          width: 16px;
          height: 16px;
          line-height: 18px;
          text-align: center;
          color: #fff;
          background: #fb973b;
          margin-right: 3px;
        }
      }
    }

  }
  .echart-bootom-tip{
    height:26px;
    line-height: 26px;
    text-align: center;
    font-size: 16px;
    background: #fff;
    color:#333;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  .box-card{
    background-color: rgb(240, 242, 245);
    margin-bottom: 10px;
    .svg-header{
      float: left;
      position: absolute;
      margin: 2px 0px 0px 4px;
      font-size: 20px;
      z-index: 6;
      cursor: pointer;
    }
  }
  .curClass{
    margin-left: 10px;
    padding:0 2px;
    font-size: 14px !important;
  }
  .box {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: left;
  }
  .line{
    width: 2px;
    height: 16px;
    line-height: 16px;
    background-color: #626365;
    display: inline-block;
    margin-right: 10px;
  }
  .box p span {
    font-size: 20px;
    color: #626365;
    font-weight: 300;
  }
  .order {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
  }
  .order .lists {
    width: 13.3%;
    height: 108px;
    cursor: pointer;
    display: flex;
    background:#30C7C9;
    border-radius: 10px;
  }
  .listsxianshi{
    position: relative;
  }
  .money-none{
    position: absolute;
    right: -90px;
    top: 6px;
    animation: dongHua normal 1.2s ease-in-out;
    p{
      width: 135px;
      font-size: 14px;
      text-align: left;
    }
  }
  @-webkit-keyframes dongHua {
    0% {
        opacity:0.1;
    }
    25% {
        opacity:0.25;
    }
    50% {
        opacity:0.5;
    }
    75% {
        opacity:0.75;
    }
    100% {
        opacity:1;
    }
  }
  .down-class{
    display: flex;
    flex-direction: column ;
    color:#666666;
    div{
      width: 100%;
      height: 54px;
    }
    .left{
      text-align: center;
      position: relative;
      left: 15px;
      top:10px
    }
    .right{
      text-align: center;
      position: relative;
      right: 30px;
    }
  }
  .imgs {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .amount {
    flex: 1;
    height: 108px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .amount p {
    font-size: 18px;
    color: #666666;
    font-weight: bold;
    margin-top: 5px;
  }
  .cur {
    color: #fff !important;
    background-color:#30C7C9;
    border-color:#30C7C9;
  }
  // .content {
  //   width: 100%;
  // }
  .simpleDemo {
    width: 100%;
    height: 500px;
    margin-top: 10px;
    background: #fff;
    border: 1px solid rgba(83,130,152,.2);
  }
  @media screen and (max-width: 750px){
    .box p span{
      font-size: 22px;
    }
    .order{
      margin-top: 40px;
      flex-direction: column;
    }
    .lists{
      width: 100%!important;
      margin-top: 3px;
    }
    .panel-block{
      flex-direction: column;
    }
    .white-box{
      width: 100%!important;
    }
    .wrapl{
      width: 100%!important;
    }
    .wrapr{
      display: inline!important;
    }
    .money-none{
      position: absolute;
      right: -15px;
      top: 15px;
      p{
        width: 135px;
        font-size: 14px;
        text-align: right;
      }
    }
  }

.svg-refresh{
  float: left;
  position: absolute;
  padding-top: 3px;
  padding-left: 9px;
  font-size: 30px;
  z-index: 6;
  cursor: pointer;
}
//通用流量共享
.title-container {
  display: flex;
  flex-direction: column;
  .main-title {
    font-weight: bolder;
  }
  .sub-title {
    font-size: 14px;
    color: #666;
    margin-top: 4px;
  }
}
  

</style>


